export default {
    name: 'EditUser',    
    created() {
        this.MunicipalitieId = this.$parent.EditUsersObj.municipalitieId;

        this.GetMunicipalities();

        this.UserType = [
            {
                id: 1,
                name: "مـدير النظام"
            },
            {
                id: 2,
                name: 'مـوظف'
            }
        ];

        this.form.Name = this.$parent.EditUsersObj.name;
        this.form.LoginName = this.$parent.EditUsersObj.loginName;
        this.form.Phone = this.$parent.EditUsersObj.phone;
        this.form.Email = this.$parent.EditUsersObj.email;
        this.form.Id = this.$parent.EditUsersObj.id;
        this.form.UserType = this.$parent.EditUsersObj.userType;
        this.form.HospitalId = this.$parent.EditUsersObj.hospitalId;
        

        
        this.GetHospitalsName();

        //setTimeout(() => this.GetHospitalsName(), 1000);
        



    },
    data() {
       
        return {
            UserType: [],

            Municipalities: [],
            MunicipalitieId: '',

            form: {
                HospitalId: 0,
                LoginName: '',
                Phone: '',
                Password: '',
                Name: '',
                UserType: 0,
                Email: '',
            },

        
        };
    },
    methods: {


        GetMunicipalities() {
            this.$blockUI.Start();
            this.$http.GetAllMunicipalities()
                .then(response => {
                    this.$blockUI.Stop();
                    this.Municipalities = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },

        ChangeHospital() {
            this.form.HospitalId = '';
            this.GetHospitalsName();
        },


        GetHospitalsName() {
            this.$blockUI.Start();
            this.$http.GetHospitalsAllName(this.MunicipalitieId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.Hospitals = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },


        Back() {
            this.$parent.state = 0;
        },





       
       
        validPhone: function (Phone) {

            var mobileRegex = /^09[1|2|3|4|5][0-9]{7}$/i;

            return mobileRegex.test(Phone);
        },

        validEmail: function (email) {
            var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validLoginName: function (LoginName) {
            var login = /^[a-zA-Z]{0,40}$/;
            return login.test(LoginName);
        },
        validFullName: function (FullName) {
            var loginArabic = /^[\u0621-\u064A\u0660-\u0669 ]+$/;
            return loginArabic.test(FullName);
        },

     




        Edit(){
            this.$blockUI.Start();
            if (!this.form.Email) {
                this.$message({
                    type: 'error',
                    message: 'الرجاء إدخال البريد الإلكتروني '
                });
                return;
            } else if (!this.validEmail(this.form.Email)) {
                this.$message({
                    type: 'error',
                    message: 'الرجاء إدخال البريد الإلكتروني بطريقه صحيحه '
                });
                return;
            }


            if (!this.form.Phone) {
                this.$message({
                    type: 'error',
                    message: 'الرجاء رقم الهاتف '
                });
                return;
            } else if (!this.validPhone(this.form.Phone)) {
                this.$message({
                    type: 'error',
                    message: 'الرجاء إدخال رقم الهاتف  بطريقه صحيحه '
                });
                return;
            }
        
           
            this.$http.EditUser(this.form)
                .then(response => {
                    
                    this.$message({
                        type: 'info',
                        message: response.data
                    });
                    this.$parent.EditUsersObj = [];
                    this.$parent.GetInfo(this.pageNo);
                    this.$parent.state = 0;
                    this.$blockUI.Stop();
                 
                })
                .catch((err) => {
                    this.$message({
                        type: 'error',
                        message: err.response.data
                    });
                    this.$blockUI.Stop();
                });
        }




    }    
}
